<template>
  <patientComponent :hireState="2"></patientComponent>
</template>
<script>

import patientComponent from '@/components/fetalMonitor/patient.vue'
export default {
  name: `fetalMonitorsource`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    patientComponent
  }
}
</script>

<style lang="scss" scoped>
</style>